import type { LocaleContext } from "@reco/shared/src/composables/useLocale";

export function setNavLangUrls(locale: LocaleContext) {
  if (import.meta.server) return;

  if (!globalThis.navLangUrls) {
    return;
  }

  const navLangUrls = globalThis.navLangUrls.get();
  if (!navLangUrls || typeof navLangUrls !== "object") {
    return;
  }

  const route = useRoute();
  const pathPrefix = `/r/${locale.language}-${locale.country}/`;
  const productPath = route.path.replace(pathPrefix, "");

  const newNavLangUrls: Record<string, string> = {};

  for (const langKey of Object.keys(navLangUrls)) {
    newNavLangUrls[langKey] = `/r${navLangUrls[langKey]}${productPath}`;
  }

  globalThis.navLangUrls.replace(newNavLangUrls);
}
